import { useSelector } from 'react-redux'
import { PATH_HELPERS } from '../../../constants/navigation'
import { selectCustomerId } from '../../../store/selectors/customerProfile'
import emptyImage from '../../../assets/homes/img/empty.svg'
import { ReactNode } from 'react'
import { Flex, LinkButton, Text } from '@homebotapp/hb-react-component-catalog'
import { Link as ReactRouterLink } from 'react-router-dom'

export interface EmptyStateProps {
  copy: string | ReactNode
  ctaCopy: string | ReactNode
}

export const EmptyState = ({ copy, ctaCopy }: EmptyStateProps) => {
  const customerId = useSelector(selectCustomerId)

  return (
    <Flex direction='column' alignItems='center' paddingY={16}>
      <img src={emptyImage} alt='' height='59px' width='83px' />
      <Text size='lg' align='center' padding={4} color='neutral.900'>
        {copy}
      </Text>
      <LinkButton as={ReactRouterLink} to={PATH_HELPERS.homeSearch.buildPath(customerId)} colorScheme='brand'>
        {ctaCopy}
      </LinkButton>
    </Flex>
  )
}
